import React, { useEffect } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css'

const Data = () => {
  useEffect(() => {
    Aos.init({ duration: 500 })
  }, [])

  return (
    <div className="home__data">
      <h1 className="home__title" data-aos="fade-up">
        <span class="title__vedant">Vedant&nbsp;</span>
        <span className="title__patil">Patil</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          enable-background="new 0 0 32 32"
          viewBox="0 0 32 32"
          className="home__hand"
        >
          <path
            fill="#FFE0B2"
            d="M20.335,11.5l-5.622,0.121L15.674,14h-0.028l-1.551-3.58c-0.231-0.535-0.87-0.759-1.386-0.486
				l-0.304,0.161c-0.75,0.397-1.022,1.337-0.6,2.073l1.04,1.812l-1.082-1.83c-0.291-0.492-0.935-0.64-1.412-0.325l-0.178,0.118
				C9.481,12.398,9.307,13.318,9.745,14H9.558v3.5c0,1.643,0.803,3.088,2.027,4h-0.027L11.473,31H19.5l0.058-9.5h-0.021l2.698-3.388
				c0.602-0.755,0.791-1.754,0.508-2.677c-0.365-1.188-0.956-2.313-1.337-3.23C21.227,11.772,20.804,11.494,20.335,11.5z"
          />
          <path
            fill="#FFE0B2"
            d="M13.24,14.64c0.31,0.53,0.16,1.21-0.34,1.57c-0.21,0.15-0.44,0.22-0.681,0.22
				c-0.35,0-0.689-0.16-0.92-0.45l-1.47-1.85c-0.55-0.69-0.39-1.7,0.34-2.19l0.18-0.12c0.48-0.31,1.12-0.16,1.41,0.33L13.24,14.64z"
          />
          <path
            fill="#FFE0B2"
            d="M15.78 14.32c.25.57.02 1.23-.521 1.52-.18.1-.38.15-.569.15-.41 0-.811-.22-1.03-.6l-1.851-3.22c-.43-.74-.159-1.68.591-2.08l.31-.16c.51-.27 1.15-.04 1.38.49L15.78 14.32zM21.02 1.59c.61.2.95.85.761 1.46l-2.761 9.26-2.06-.6-1.92.74-3.59-9.294c-.05-.14-.08-.29-.08-.43 0-.47.27-.91.71-1.1.59-.25 1.27 0 1.55.58L16.9 9.25l2.63-6.96C19.76 1.7 20.42 1.39 21.02 1.59z"
          />
          <path
            fill="#FFE0B2"
            d="M15.698,11.5h4.927c0.376,0,0.711,0.237,0.835,0.592l1.487,4.248c0.25,0.71,0.08,1.5-0.44,2.05
				l-3.847,4.441l-0.103-8.641l-2.045-0.262c-0.581-0.074-1.063-0.484-1.231-1.045l-0.176-0.587
				C14.986,11.899,15.284,11.5,15.698,11.5z"
          />
          <path
            fill="#EAC89B"
            d="M18.563,14.188c-0.002,0.001-0.003,0.001-0.005,0.002c-1.356-0.183-3.122-0.336-3.122-0.336l0.149,0.344
				c0.245,0.567,0.018,1.228-0.525,1.522c-0.569,0.309-1.281,0.107-1.604-0.454l-0.177-0.308h-0.091
				c0.223,0.508,0.079,1.108-0.385,1.434c-0.512,0.36-1.216,0.259-1.605-0.231l-1.47-1.851c-0.173-0.218-0.268-0.47-0.304-0.726
				C9.438,13.886,9.5,14.101,9.5,14.101v3.5c0,1.623,0.833,3.274,2.184,4.232l0.892,0.384c0,0,1.955,0.262,1.955-1.53
				c0-3.191,2.757-4.499,4.032-4.934V14.188z"
          />
          <path
            fill="#455A64"
            d="M12.22,16.93c-0.511,0-0.988-0.233-1.312-0.639l-1.47-1.85c-0.348-0.436-0.498-1.002-0.413-1.554
				c0.086-0.553,0.401-1.05,0.865-1.362l0.181-0.121c0.712-0.459,1.702-0.212,2.119,0.491l1.479,2.49
				c0.443,0.759,0.237,1.716-0.478,2.231C12.899,16.825,12.573,16.93,12.22,16.93z M10.896,12.158c-0.097,0-0.192,0.028-0.274,0.082
				l-0.173,0.116c-0.236,0.159-0.391,0.402-0.435,0.684c-0.043,0.281,0.03,0.557,0.207,0.779l1.471,1.851
				c0.224,0.282,0.627,0.341,0.918,0.134c0.293-0.211,0.379-0.603,0.199-0.911l-1.479-2.487
				C11.238,12.25,11.076,12.158,10.896,12.158z"
          />
          <path
            fill="#455A64"
            d="M14.69,16.49c-0.6,0-1.16-0.326-1.463-0.85l-1.852-3.222c-0.274-0.473-0.345-1.025-0.194-1.552
				c0.149-0.527,0.499-0.959,0.983-1.218l0.315-0.163c0.729-0.384,1.734-0.035,2.068,0.735l1.69,3.9
				c0.35,0.798,0.023,1.748-0.743,2.159C15.252,16.417,14.972,16.49,14.69,16.49z M13.168,10.316c-0.079,0-0.154,0.019-0.224,0.056
				l-0.314,0.162c-0.236,0.126-0.412,0.343-0.486,0.606c-0.075,0.263-0.04,0.54,0.099,0.778l1.852,3.222
				c0.18,0.313,0.596,0.444,0.923,0.262c0.317-0.17,0.448-0.556,0.306-0.882l-1.691-3.902
				C13.552,10.435,13.369,10.316,13.168,10.316z"
          />
          <path
            fill="#455A64"
            d="M15.04 12.95c-.2 0-.39-.122-.467-.32l-3.59-9.294c-.075-.212-.113-.419-.113-.61 0-.682.397-1.294 1.012-1.559.844-.357 1.804.007 2.198.822l2.773 5.972 2.209-5.848c.33-.848 1.258-1.283 2.115-.998.863.283 1.349 1.218 1.08 2.083l-2.465 8.442c-.077.264-.355.417-.619.34-.266-.078-.418-.355-.34-.62l2.467-8.45c.109-.355-.087-.73-.438-.845-.346-.115-.734.068-.867.406l-2.628 6.956c-.071.188-.248.315-.449.323-.234.009-.388-.106-.472-.289l-3.271-7.044c-.159-.329-.56-.477-.901-.33-.245.105-.405.357-.405.64 0 .077.019.169.051.262l3.586 9.282c.099.258-.029.547-.287.646C15.161 12.939 15.1 12.95 15.04 12.95zM19.486 31.044c-.273 0-.496-.219-.5-.493l-.119-8.448c-.004-.276.217-.503.493-.507.236.009.503.217.507.493l.119 8.448c.004.276-.217.503-.493.507C19.491 31.044 19.488 31.044 19.486 31.044zM11.5 31.04c-.007 0-.014 0-.021 0-.275-.011-.49-.244-.479-.52l.349-8.602c.012-.276.261-.494.521-.479.275.011.49.244.479.52L12 30.56C11.988 30.829 11.768 31.04 11.5 31.04zM14.713 19.543c-.082 0-.164-.02-.24-.062-.242-.133-.331-.437-.198-.679.891-1.625 2.34-2.859 4.081-3.475.261-.093.546.043.639.304.092.261-.045.546-.305.638-1.509.534-2.766 1.604-3.538 3.013C15.061 19.449 14.889 19.543 14.713 19.543z"
          />
          <path
            fill="#455A64"
            d="M18.66 23.331c-.115 0-.231-.04-.325-.121-.21-.18-.234-.495-.055-.705l3.467-4.042c.58-.676.756-1.617.461-2.457l-1.292-3.673c-.07-.2-.26-.334-.472-.334H15.5c0 .723.54 1.342 1.257 1.44l1.813.255C18.816 13.729 19 13.941 19 14.19v1.622c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-1.188l-1.38-.194C15.412 14.266 14.5 13.221 14.5 12c0-.551.448-1 1-1h4.944c.636 0 1.204.403 1.415 1.002l1.292 3.673c.413 1.175.166 2.493-.645 3.439l-3.467 4.042C18.94 23.272 18.801 23.331 18.66 23.331zM12.575 22.717c-.064 0-.13-.012-.192-.039C10.328 21.821 9 19.828 9 17.601v-4.4c0-.276.224-.5.5-.5s.5.224.5.5v4.4c0 1.822 1.087 3.453 2.768 4.155.255.106.375.399.269.654C12.956 22.602 12.771 22.717 12.575 22.717zM1.5 21c-.215 0-.414-.14-.479-.356-.08-.264.07-.543.335-.623l5-1.5c.264-.078.543.07.622.335.08.264-.07.543-.335.623l-5 1.5C1.596 20.993 1.548 21 1.5 21zM6.5 13.5c-.062 0-.125-.011-.186-.036l-2.501-1c-.257-.103-.381-.394-.278-.65.103-.257.394-.383.649-.279l2.501 1c.257.103.381.394.278.65C6.886 13.381 6.698 13.5 6.5 13.5zM2.488 11.895c-.062 0-.125-.011-.186-.036l-.988-.395c-.257-.103-.381-.394-.278-.65.103-.257.395-.381.649-.279l.988.395c.257.103.381.394.278.65C2.874 11.776 2.687 11.895 2.488 11.895zM9 10c-.118 0-.237-.042-.332-.126l-4.5-4c-.206-.183-.226-.5-.042-.706.184-.207.5-.227.706-.042l4.5 4c.206.183.226.5.042.706C9.275 9.943 9.138 10 9 10zM25 12.5c-.189 0-.371-.109-.455-.293-.114-.251-.003-.548.248-.662l2.614-1.188c.253-.115.548-.003.662.248.114.251.003.548-.248.662l-2.614 1.188C25.14 12.486 25.069 12.5 25 12.5zM29.4 10.5c-.189 0-.371-.109-.455-.293-.114-.251-.003-.548.248-.662l1.1-.5c.252-.113.548-.003.662.248s.003.548-.248.662l-1.1.5C29.54 10.486 29.47 10.5 29.4 10.5zM27.615 20.951c-.057 0-.114-.01-.171-.03l-2.615-.951c-.26-.094-.394-.381-.299-.641.094-.259.38-.394.641-.299l2.615.951c.26.094.394.381.299.641C28.012 20.825 27.819 20.951 27.615 20.951zM30.5 22c-.057 0-.114-.01-.171-.03l-1.232-.448c-.26-.094-.394-.381-.299-.641.094-.259.381-.392.641-.299l1.232.448c.26.094.394.381.299.641C30.896 21.874 30.704 22 30.5 22zM24 9.5c-.128 0-.256-.049-.354-.146-.195-.195-.195-.512 0-.707l3-3c.195-.195.512-.195.707 0s.195.512 0 .707l-3 3C24.256 9.451 24.128 9.5 24 9.5z"
          />
        </svg>
      </h1>
      <h3 className="home__subtitle" data-aos="fade-up">
        <div className="subline">Student</div>
        <div className="subline">Engineer</div>
        <div className="subline">Programmer</div>
        <div className="subline">Developer</div>
      </h3>
      <p className="home__description" data-aos="fade-up">
        Hey, there! My name is Vedant and I am a 22-year-old{' '}
        <span className="home__description-highlight">
          Computer Engineering Graduate
        </span>
        . I am particularly passionate about{' '}
        <span className="home__description-highlight">web development</span>,
        worked in {''}
        <span className="home__description-highlight">
          MERN, MEAN, and Spring Boot.{' '}
        </span>
        I've interned at{' '}
        <span className="home__description-highlight">
          Flytbase, Barclays, and PHN Technology
        </span>
        , building projects that enhance user experiences. {' '}
        <span className="home__description-highlight">
          Let's connect and collaborate!{' '}
        </span>
      </p>

      <a
        href="mailto:vedantpatil2002@gmail.com?subject=Hello from Abstract!&body=Just popped in to say hello"
        className="button button--flex sayhelloButton "
        data-aos="fade-up"
      >
        Say Hello
        <svg
          class="button__icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M14.2199 21.9352C13.0399 21.9352 11.3699 21.1052 10.0499 17.1352L9.32988 14.9752L7.16988 14.2552C3.20988 12.9352 2.37988 11.2652 2.37988 10.0852C2.37988 8.91525 3.20988 7.23525 7.16988 5.90525L15.6599 3.07525C17.7799 2.36525 19.5499 2.57525 20.6399 3.65525C21.7299 4.73525 21.9399 6.51525 21.2299 8.63525L18.3999 17.1252C17.0699 21.1052 15.3999 21.9352 14.2199 21.9352ZM7.63988 7.33525C4.85988 8.26525 3.86988 9.36525 3.86988 10.0852C3.86988 10.8052 4.85988 11.9052 7.63988 12.8252L10.1599 13.6652C10.3799 13.7352 10.5599 13.9152 10.6299 14.1352L11.4699 16.6552C12.3899 19.4352 13.4999 20.4252 14.2199 20.4252C14.9399 20.4252 16.0399 19.4352 16.9699 16.6552L19.7999 8.16525C20.3099 6.62525 20.2199 5.36525 19.5699 4.71525C18.9199 4.06525 17.6599 3.98525 16.1299 4.49525L7.63988 7.33525Z"
            fill="var(--container-color)"
          ></path>
          <path
            d="M10.11 14.7052C9.92005 14.7052 9.73005 14.6352 9.58005 14.4852C9.29005 14.1952 9.29005 13.7152 9.58005 13.4252L13.16 9.83518C13.45 9.54518 13.93 9.54518 14.22 9.83518C14.51 10.1252 14.51 10.6052 14.22 10.8952L10.64 14.4852C10.5 14.6352 10.3 14.7052 10.11 14.7052Z"
            fill="var(--container-color)"
          ></path>
        </svg>
      </a>
    </div>
  )
}

export default Data
